<template>
  <!--begin::Advance Table Widget 9-->
  <div
    class="card card-custom card-stretch gutter-b"
    style="background: transparent;"
  >
    <!--begin::Header-->
    <div class="row m-0 col-12 p-2 border-r-16">
      <div class="col-md-4 p-0">
        <span class="leatext_job_heading_by_new_home">Saved Jobs</span>
      </div>
      <div class="col-md-8 p-0 row m-0" style="align-items: center">
        <router-link
          class="text-end"
          style="
              font-size: 16px;
              color: rgb(3, 169, 244) !important;
              text-decoration: underline !important;
            "
          :to="{ path: '/job-seeker/saved-jobs' }"
        >
          view all applications</router-link
        >
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="pt-0 pb-3 px-4">
      <div class="empty_div_jobsAdd" v-if="data.length == 0">
        <a href="/jobs-in-pakistan">Click here to see the latest jobs</a>
      </div>
      <div class="row">
        <div class="col-md-12 row m-0 mt-4 pt-0 pr-0 pl-0 ">
          <!--begin::Table-->
          <div
            class="col-md-4  row m-0 mt-4 pt-0 pr-0"
            v-for="(item, index) in data.filter(
              (item) => item.archive == '0' && item.draft == '0'
            )"
            :key="index"
            :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
          >
            <!-- {{item.apply_by}} -->
            <div
              class="col-md-12 row m-0 border-r-16 p-4"
              :class="
                detail1 && detail1.id === item.id ? 'bg-info-new' : 'bg-white'
              "
            >
              <div class="col-md-12 p-0">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ item.job_title }}
                </h4>
              </div>

              <div class="col-md-12 p-0">
                <div class="m-0" style="color: #666; font-size: 14px">
                  <h4
                    class="
                          widget-title
                          tooltipch
                          mb-0
                          mt-3
                          bold
                          detail_heading
                        "
                  >
                    <img
                      src="/images/job_page/Location_left.svg"
                      alt="..."
                      class="pr-4"
                    /><span class="tooltiptextch">Job Location</span>
                  </h4>
                  <p
                    v-if="item.location_city"
                    class="col col-md-3 text-primary mb-0 detail_body"
                    style="display: contents"
                  >
                    <span
                      v-for="(_item, _index) in item && item.location_city"
                      :key="_index"
                      style="display: inline-flex"
                    >
                      <span
                        v-if="_index > 0 && _index < item.location_city.length"
                        style=""
                        >&nbsp;,&nbsp;</span
                      >
                      {{ _item }}
                    </span>
                    <span v-if="item.location_city == ''">Not add</span>
                  </p>
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-md-12 p-0 py-2">
                <div class="m-0" style="color: #666; font-size: 14px">
                  <h4 class="widget-title tooltipch mb-0 bold detail_heading">
                    <img
                      src="/images/job_page/Money_left.svg"
                      alt="..."
                      class="pr-2"
                    /><span class="tooltiptextch">Per month salary</span>
                  </h4>
                  <span
                    v-if="
                      item.salary_min != NULL &&
                        item.salary_market_competitive != 1 &&
                        item.salary_depends_on_exp != 1
                    "
                    >{{ item.salary_min }} - {{ item.salary_max }}</span
                  >
                  <span v-if="item.salary_market_competitive == 1">
                    Salary market competitive</span
                  >
                  <span v-if="item.salary_depends_on_exp == 1">
                    Salary depends on exp</span
                  >
                  <span
                    v-if="
                      item.salary_min == NULL &&
                        item.salary_market_competitive != 1 &&
                        item.salary_depends_on_exp != 1
                    "
                  >
                    Not add</span
                  >
                </div>
              </div>
              <div class="col-md-12 p-0 pb-2">
                <div class="m-0" style="color: #666; font-size: 14px">
                  <h4 class="widget-title tooltipch mb-0 bold detail_heading">
                    <img
                      src="/images/job_page/Due_date.svg"
                      alt="..."
                      class="pr-4"
                    /><span class="tooltiptextch">Expiry Date</span>
                  </h4>
                  <span>{{
                    moment(item.apply_by).format("DD MMM, YYYY")
                  }}</span>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-4"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="col-md-12  p-0 m-0">
                <router-link
                  class="col-12 p-0 pt-3 text-center"
                  style="width: 320px;min-width: 100%;background: rgba(53, 162, 229, 0.05);border: 1px solid rgba(53, 162, 229, 0.5);border-radius: 4px;padding: 5px !important;display: block;"
                  :to="`/job-seeker/saved-jobs?${item.id}`"
                >
                  View Application</router-link
                >
                <!-- <div class="p-0" @click="singleDetail1(item)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2 back_fill_job"
                  >
                    view Job Details
                  </button>
                </div> -->
                <!-- <div class="p-0">
                  <button
                    @click="deleteJob(item)"
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                            background: rgba(147, 6, 6, 0.05) !important;
                            border-color: rgba(147, 6, 6, 0.5) !important;
                            padding: 0px !important;
                            margin-right: 10px;
                          "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div> -->
                <!-- <div class="p-0" style="">
                      <button
                        type="button"
                        class="new_details_job_dashbord_list2"
                      >
                        <div
                          @contextmenu="handler($event)"
                          @click="editButtonClick(item.id)"
                        >
                          <span class="v-btn__content">Edit</span>
                        </div>
                      </button>
                    </div> -->
                <!-- <div
                      class="p-0"
                      style="position: relative"
                      @click="jobArchive(item)"
                    >
                      <button
                        type="button"
                        class="
                          new_details_job_dashbord_list2
                          tooltipch
                          archive_buton
                        "
                      >
                        <img
                          class="dashbord"
                          src="\images/job_page/archive.png"
                          alt=""
                          width="16"
                          height="16"
                        />
                        <span class="tooltiptextch gray">Archive Job</span>
                      </button>
                    </div> -->
              </div>
              <div class="col-12 px-0 pt-4 m-0 info_short_leatesd">
                <img src="/images/job_application/InfoCircle.svg" class="" />
                <span>
                  Added:
                  {{ moment(item.created_at).format("DD MMM, YYYY") }}
                </span>
              </div>
              <!-- <div
                    class="col-4 px-0 pt-4 m-0 info_short_leatesd text-end"
                  >
                    <span
                    @click="deleteJob(item)"
                      style="color: rgb(231 37 8); cursor: pointer"
                      >Delete job</span
                    >
                  </div> -->
            </div>
          </div>
        </div>
        <!--end::Table-->
      </div>
    </div>
    <!-- </div> -->
    <!--end::Body-->
  </div>
  <!--end::Advance Table Widget 9-->
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { API_URL, MEDIA_URL } from "@/core/api";
import Router from "vue-router";

export default {
  data() {
    return {
      search: "",
      loading: true,
      success: false,
      originalData: [],
      mediaUrl: MEDIA_URL,
      token: `Bearer ${localStorage.getItem("token")}`,
      headers: [
        { text: "Job Title", value: "job_title" },
        { text: "City", value: "location_city" },
        { text: "Salary Min.", value: "salary_min" },
        { text: "Salary Max.", value: "salary_max" },
        { text: "Job Type", value: "job_type" },
        { text: "Action", value: "action" },
      ],
      data: [],
      detail1: null,
      alwyes: true,
    };
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.fetch();
  },
  methods: {
    moment: function(date) {
      return moment(date);
    },
    fetch() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/get-save-jobs`)
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.alwyes = false;
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    viewJob(item) {
      let routeData = this.$router.resolve({
        path:
          "/jobs-careers/pakistan/" +
          item.location_city.map((v) => v.toLowerCase()).join("-") +
          "/" +
          item.job_title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "/" +
          item.id,
        params: {
          search_text: this.search_text,
          selected_cities: [{ id: 1, value: item }],
        },
      });
      window.open(routeData.href, "_blank");
    },
    deleteJob(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .delete(`${API_URL}/delete-save-job/${item.id}`)
        .then((res) => {
          this.fetch();
          Swal.fire({
            title: "",
            text: "Application has been deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
    },
    job_link(item) {
      let routeData = this.$router.resolve({
        path:
          "/jobs-careers/pakistan/" +
          item.location_city.map((v) => v.toLowerCase()).join("-") +
          "/" +
          item.job_title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "/" +
          item.id,
        // params: {
        //   search_text: this.search_text,
        //   selected_cities: [{ id: 1, value: item }],
        // },
      });
      return routeData.href;
    },
  },
};
</script>
